import { Component, OnInit, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EditProductForm } from '../../../../components/admin-dashboard-component/products/edit-product-form/edit-product-form';

@Component({
  selector: 'app-edit-product',
  imports: [EditProductForm],
  templateUrl: './edit-product.html',
  styleUrl: './edit-product.scss',
})
export class EditProduct implements OnInit {
  productId = signal<number | null>(null);
  productType = signal<'has-sub' | 'has-no-sub' | 'sub-product' | null>(null);
  subProductId = signal<number | null>(null);
  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    const productId = this.route.snapshot.params['id'];
    const subProductId = this.route.snapshot.params['subId'];

    this.productId.set(productId ? +productId : null);
    this.subProductId.set(subProductId ? +subProductId : null);
    if (productId.startsWith('1')) {
      this.productType.set('has-no-sub');
    }
    if (productId.startsWith('2')) {
      this.productType.set('has-sub');
    }
    if (this.subProductId()) {
      this.productType.set('sub-product');
    }
  }
}
